import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "details"]

  toggle(event) {
    const clickedRow = event.currentTarget
    const detailsRow = clickedRow.nextElementSibling

    if (detailsRow && detailsRow.hasAttribute('data-toggle-monthly-detailed-sales-target')) {
      detailsRow.classList.toggle("d-none")

      const button = clickedRow.querySelector("button")
      if (button) {
        button.textContent = detailsRow.classList.contains("d-none") ? "Show Details" : "Hide Details"
      }
    }
  }
}
